module.exports = __webpack_public_path__ + "static/img/P.b05b519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/P.png
// module id = gPhq
// module chunks = 0